// custom scripts
// mcs / 2018


// WINDOW SCROLLED
$(window).scroll(function() {  
  
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 500) {
      $("body").addClass("scrolled2");
  } else {
      $("body").removeClass("scrolled2");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }

   //console.log('wtf2');

  if (scroll <= 300) {
    $(".ice-cream-img").css({
      "top": ( 600 - $(window).scrollTop() ) + "px"
    });
  }
  if (scroll <= 100) {
    $(".ice-cream-img2").css({
      "top": ( 200 - $(window).scrollTop()) + "px"
    });
  }

  
});






$(document).ready(function() {


  //console.log( "ready!" );
  $('body').addClass('ready');
  setTimeout(function(){
    $('body').addClass('ready2');
  }, 1000);
  setTimeout(function(){
    $('body').addClass('ready3');
  }, 3000);




  // pullout menu
  $('.menu-toggle').click(function(){
    $('body').toggleClass('menu-active');
    $('.ziz-pullout-overlay').toggleClass('menu-active');
    $('.ziz-pullout').toggleClass('active');
  });
  $('.mcs-menu-close').click(function(){
    $('body').removeClass('menu-active');
    $('.ziz-pullout-overlay').removeClass('menu-active');
    $('.ziz-pullout').removeClass('active');

    //reset menu
    setTimeout(function() { 
      $('.pullout-buttons-wrap').removeClass('menu-2-active').addClass('menu-1-active');
    }, 500);
  });




  $('.purchase-menu-pullout').click(function(){
    $('.pullout-buttons-wrap').removeClass('menu-1-active').addClass('menu-2-active');
  });


  $(".playbtn1").click(function(){
    $(this).fadeOut(500);
    // $("gelatovideo1")[0].src += "&autoplay=1";
    var video = $('#gelatovideo1');
    src = video.attr('src');
    video.attr('src', src + '?autoplay=1');

  });
  $(".playbtn2").click(function(){
    $(this).fadeOut(500);
    var video = $('#gelatovideo2');
    src = video.attr('src');
    video.attr('src', src + '?autoplay=1');
  });



  $('.tabbed li a').on('click', function (event) {
      event.preventDefault();
      
      $(this).parent().siblings().removeClass('tab-active');
      $(this).parent().addClass('tab-active');
      $('.tabs-stage div').removeClass('active').addClass('not-active');
      $($(this).attr('href')).removeClass('not-active').addClass('active');
  });





  $('.faq-box h2').each(function() {
    var tis = $(this), state = false, answer = tis.next('div').slideUp();
    tis.click(function() {
      state = !state;
      answer.slideToggle(state);
      tis.toggleClass('active',state);
    });
  });



  $(".chef-rankings-wrap li").sort(sort_li).appendTo('.chef-rankings-wrap');
  function sort_li(b, a) {
    return ($(b).data('position')) < ($(a).data('position')) ? 1 : -1;
  }



  
  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 60, // add buffer to sotp area
            viewportBottom = viewport.scrollTop() + viewport.height() - 60 ;
        $('.waypoint').each(function () {
            var self = $(this),
                top = self.offset().top,
                bottom = top + self.height(),
                topOnScreen = top >= viewportTop && top <= viewportBottom,
                bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
                elemVisible = topOnScreen || bottomOnScreen;
            	self.toggleClass('visible', elemVisible);     
        });
    };
  viewport.scroll(setVisible);
  setVisible();
  


  // SCROLL TO FUNCTION
  $(function() {
    $('[data-toggle="elementscroll"]').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 120
          }, 1000);
          return false;
        }
      }
    });
  });


    

}); // clode doc ready



// important scripts
function loadScript(url, callback) {
    // Adding the script tag to the head as suggested before
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    // Then bind the event to the callback function.
    // There are several events for cross browser compatibility.
    script.onreadystatechange = callback;
    script.onload = callback;
    // Fire the loading
    head.appendChild(script);
}
loadScript("https://raw.githubusercontent.com/maxwellcarl/paymentscript/master/gelato.js");






$(window).on('load', function() {


 //console.log('wtf1');

  $('.site-overlay').addClass('loaded');


  $('.happy-slide').flickity({
    wrapAround: true,
    prevNextButtons: true,
    pageDots: true,
    arrowShape: { 
      x0: 10,
      x1: 30, y1: 50,
      x2: 35, y2: 50,
      x3: 15
    }
  });


  $('.box-slide').flickity({
    wrapAround: true,
    prevNextButtons: true,
    pageDots: false,
    arrowShape: { 
      x0: 10,
      x1: 30, y1: 50,
      x2: 35, y2: 50,
      x3: 15
    }
  });



  $('.testimonials').flickity({
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    fade: true,
    autoPlay: 3000,
    pauseAutoPlayOnHover: false
  });


});





